import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

import api from "assets/services/api";


function ModalRemoveInHands(props) {

    const [br, setBR] = useState(false);

    const [name, setName] = useState("");
    const [cpf, setCpf] = useState();
    const [mask, setMask] = useState("");

    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);


    async function handleRemoveInHands(e) {
        e.preventDefault();
        const response = await api.post('sell/ask/forRemoveInhands/'+ storageId + '/'+ props.props.nf, {
            name,
            cpf
        })
        setControlSnack(true);
        props.loadSell();
        props.loadTotal();
        props.onHide();
        setControlSnack(false);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Configurar retirada em mãos
          </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleRemoveInHands}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control onChange={event => setName(event.target.value)} type="text" placeholder="Nome da pessoa que irá retirar" value={name} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridCPF">
                            <Form.Label>CPF</Form.Label>
                            <CpfCnpj
                                value={cpf}
                                className="form-control"
                                placeholder="CPF da pessoa que irá retirar"
                                type="tel"
                                onChange={(event, type) => {
                                    setCpf(event.target.value);
                                    setMask(type === "CPF");
                                }}
                            />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Concluir
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Retirada em mãos adicionada com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalRemoveInHands;